// Sverige
export default {
	tabs: ["Uttag", "Historik"],
	History: {
		tabs: ["Granskar", "Lyckades", "Avvisad"]
	},
	Withdraw: {
		label: ["Kontonummer", "Ordernummer", "Adress", "Belopp", "Avgift", "Skapad den", "Status", "Anledning"]
	},
	AccountAmount: "Kontobelopp",
	tips: "Du kommer att få ditt uttag inom en timme",
	form: {
		label: ["Belopp att ta ut", "Transaktionslösenord"],
		ALL: "ALLA",
		Withdraw: "Skicka in"
	},
	WithdrawAccount: "Ta ut konto",
	noAccountsTips: "Vänligen lägg till betalningsmetoder",
	tradingKind: [
		"Cashback",
		"Avdrag",
		"Påfyllning",
		"Uttag pågår",
		"Upplåsning av uttag",
		"Uttag",
		"Uppgift",
		"Återbetalning av kapital",
		"Återbetalning av provision",
		"Återbetalning av underordnad provision",
		"Incheckning",
		"Hanteringsavgift",
		"Insättning",
		"Belöning",
		"Grundlön",
		"Kontanthjälp",
		"Registreringsbonus",
		"Varudividender",
		"Uppgiftsbonus",
		"Övrigt",
		"",
		"Arbetsbonus",
		"Uppgraderingsbelöningar",
		"Subvention",
		"Väntar på verifiering",
		"Kampanj",
		"Poänginlösen",
		"Inloggningsbelöningar",
		"Arbetsbelöningar",
		"Kreditpoängstransaktion"
	]
};
